// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"db2bcd51","708":"bd25710f","787":"2e90883a","802":"8d926e30","921":"0260e92f"}[chunkId] + ".chunk.js";
};